/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HighLevelTimeNumbers_company$ref: FragmentReference;
declare export opaque type HighLevelTimeNumbers_company$fragmentType: HighLevelTimeNumbers_company$ref;
export type HighLevelTimeNumbers_company = {|
  +id: string,
  +$refType: HighLevelTimeNumbers_company$ref,
|};
export type HighLevelTimeNumbers_company$data = HighLevelTimeNumbers_company;
export type HighLevelTimeNumbers_company$key = {
  +$data?: HighLevelTimeNumbers_company$data,
  +$fragmentRefs: HighLevelTimeNumbers_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelTimeNumbers_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Company"
};
// prettier-ignore
(node/*: any*/).hash = '650e7e75b816b0631475bba318dff414';

module.exports = node;
